function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 300,
  width: 1440,
  height: 400,
  fill: "url(#paint0_linear_52518_36985)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 300,
  width: 1440,
  height: 400,
  fill: "url(#paint1_linear_52518_36985)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_52518_36985)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M424.053 300L0 448.424",
  stroke: "url(#paint2_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.097 300L0 398.041",
  stroke: "url(#paint3_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.15 300L0 364.447",
  stroke: "url(#paint4_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M498.011 300L0 532.38",
  stroke: "url(#paint5_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.194 300L0 340.447",
  stroke: "url(#paint6_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.2818 300L0 308.447",
  stroke: "url(#paint7_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.238 300L0 322.446",
  stroke: "url(#paint8_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1237.55 300L1440 340.52",
  stroke: "url(#paint9_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M719.868 300L719.373 700",
  stroke: "url(#paint10_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1311.51 300L1440 322.499",
  stroke: "url(#paint11_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1385.46 300L1440 308.489",
  stroke: "url(#paint12_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1163.59 300L1439.99 364.545",
  stroke: "url(#paint13_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1089.64 300L1440 398.176",
  stroke: "url(#paint14_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M941.731 300L1439.99 532.767",
  stroke: "url(#paint15_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1015.69 300L1440 448.643",
  stroke: "url(#paint16_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M793.827 300L1078.92 700",
  stroke: "url(#paint17_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.958 300L0.304688 700",
  stroke: "url(#paint18_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.779 300L1438.45 700",
  stroke: "url(#paint19_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M645.911 300L359.836 700",
  stroke: "url(#paint20_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1438.45 699.224H0.304688",
  stroke: "url(#paint21_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 355.154H0",
  stroke: "url(#paint22_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 318.687H0",
  stroke: "url(#paint23_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 326.124H0",
  stroke: "url(#paint24_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 334.531H0",
  stroke: "url(#paint25_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 306.13H0",
  stroke: "url(#paint26_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 312.068H0",
  stroke: "url(#paint27_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 593.744H0",
  stroke: "url(#paint28_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 367.982H0",
  stroke: "url(#paint29_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 344.122H0",
  stroke: "url(#paint30_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 300.777H0",
  stroke: "url(#paint31_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 383.078H0",
  stroke: "url(#paint32_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 401.117H0",
  stroke: "url(#paint33_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 530.695H0",
  stroke: "url(#paint34_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 423.044H0",
  stroke: "url(#paint35_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 450.263H0",
  stroke: "url(#paint36_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 484.956H0",
  stroke: "url(#paint37_linear_52518_36985)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_52518_36985",
  x: -12,
  y: -12,
  width: 1464,
  height: 724,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  result: "effect1_foregroundBlur_52518_36985"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52518_36985",
  x1: 720,
  y1: 300,
  x2: 720,
  y2: 700,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_52518_36985",
  x1: 1440,
  y1: 500,
  x2: 0,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "white",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_52518_36985",
  x1: 424.053,
  y1: 374.212,
  x2: 0.00000557942,
  y2: 374.212,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_52518_36985",
  x1: 350.097,
  y1: 349.02,
  x2: 0.00000460636,
  y2: 349.02,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_52518_36985",
  x1: 276.15,
  y1: 332.223,
  x2: 0.00000363341,
  y2: 332.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_52518_36985",
  x1: 498.011,
  y1: 416.19,
  x2: 0.00000655252,
  y2: 416.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_52518_36985",
  x1: 202.194,
  y1: 320.224,
  x2: 0.00000266034,
  y2: 320.224,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_52518_36985",
  x1: 54.2818,
  y1: 304.223,
  x2: 7.14207e-7,
  y2: 304.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_52518_36985",
  x1: 128.238,
  y1: 311.223,
  x2: 0.00000168727,
  y2: 311.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_52518_36985",
  x1: 1440,
  y1: 320.26,
  x2: 1237.55,
  y2: 320.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_52518_36985",
  x1: 720.736,
  y1: 500,
  x2: 718.506,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_52518_36985",
  x1: 1440,
  y1: 311.25,
  x2: 1311.51,
  y2: 311.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_52518_36985",
  x1: 1440,
  y1: 304.245,
  x2: 1385.46,
  y2: 304.245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_52518_36985",
  x1: 1439.99,
  y1: 332.272,
  x2: 1163.59,
  y2: 332.272,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_52518_36985",
  x1: 1440,
  y1: 349.088,
  x2: 1089.64,
  y2: 349.088,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_52518_36985",
  x1: 1439.99,
  y1: 416.383,
  x2: 941.731,
  y2: 416.383,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_52518_36985",
  x1: 1440,
  y1: 374.321,
  x2: 1015.69,
  y2: 374.321,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_52518_36985",
  x1: 1078.92,
  y1: 500,
  x2: 793.827,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_52518_36985",
  x1: 571.958,
  y1: 500,
  x2: 0.304695,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_52518_36985",
  x1: 1438.45,
  y1: 500,
  x2: 867.779,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_52518_36985",
  x1: 645.911,
  y1: 500,
  x2: 359.836,
  y2: 500,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_52518_36985",
  x1: 1438.45,
  y1: 699.224,
  x2: 0.304707,
  y2: 699.259,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_52518_36985",
  x1: 1440,
  y1: 355.154,
  x2: 0.0000198033,
  y2: 355.189,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_52518_36985",
  x1: 1440,
  y1: 318.687,
  x2: 0.0000198033,
  y2: 318.722,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_52518_36985",
  x1: 1440,
  y1: 326.124,
  x2: 0.0000198033,
  y2: 326.16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_52518_36985",
  x1: 1440,
  y1: 334.531,
  x2: 0.0000198033,
  y2: 334.566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_52518_36985",
  x1: 1440,
  y1: 306.13,
  x2: 0.0000198033,
  y2: 306.165,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_52518_36985",
  x1: 1440,
  y1: 312.068,
  x2: 0.0000198033,
  y2: 312.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_52518_36985",
  x1: 1440,
  y1: 593.744,
  x2: 0.0000198033,
  y2: 593.779,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_52518_36985",
  x1: 1440,
  y1: 367.982,
  x2: 0.0000198033,
  y2: 368.017,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_52518_36985",
  x1: 1440,
  y1: 344.122,
  x2: 0.0000198033,
  y2: 344.158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear_52518_36985",
  x1: 1440,
  y1: 300.777,
  x2: 0.0000198033,
  y2: 300.812,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear_52518_36985",
  x1: 1440,
  y1: 383.078,
  x2: 0.0000198033,
  y2: 383.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_52518_36985",
  x1: 1440,
  y1: 401.117,
  x2: 0.0000198033,
  y2: 401.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear_52518_36985",
  x1: 1440,
  y1: 530.695,
  x2: 0.0000198033,
  y2: 530.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_52518_36985",
  x1: 1440,
  y1: 423.044,
  x2: 0.0000198033,
  y2: 423.079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear_52518_36985",
  x1: 1440,
  y1: 450.263,
  x2: 0.0000198033,
  y2: 450.298,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_52518_36985",
  x1: 1440,
  y1: 484.956,
  x2: 0.0000198033,
  y2: 484.991,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgHeroBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 712,
    viewBox: "0 0 1440 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_52518_36985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52518_36985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 300,
    width: 1440,
    height: 400
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52518_36985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52518_36985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 300,
    width: 1440,
    height: 400
  }, _ref3), _ref4)), _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackground);
export default __webpack_public_path__ + "static/media/HeroBackground.ee8bd03184a11c9b1bc62da3467901e7.svg";
export { ForwardRef as ReactComponent };